import React from 'react';
import { Container } from 'react-bootstrap';

const WeddingBands = () => {
    window.onmessage = function(e) {var iframeheight = e.data.frameHeight;var frame = document.getElementById("ifrm");frame.style.height = iframeheight + 'px';}
    
  return (
    <div className='wedding-bands-wrapper my-5'>
        <Container className="WbCustomeContainer">
            <div className="text-center sd_titels">
                <h1 className="font-weight-bold">Eternity Bands Builder</h1>
                {/* <img src={divider} alt="" /> */}
                <p className="mt-3">Customize Your Perfect Eternity Band</p>
            </div>
            <iframe id='ifrm' src='https://overnightmountings.com/eternity-band-builder-iframe?customerid=R59204' style={{width: "100%", height: "1400px", border: "none"}} scrolling='no'></iframe>
        </Container>
    </div>
  )
}

// [1, 3]
export default WeddingBands